/* eslint-disable jsx-a11y/anchor-is-valid */
import {yupResolver} from '@hookform/resolvers/yup'
import moment from 'moment'
import {FC, useEffect, useState, useRef} from 'react'
import {FormProvider, useForm} from 'react-hook-form'
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs'
import {KTCard} from '../../../../../../../_metronic/helpers'
import {Button, ButtonWrapper} from '../../../../../components/UI/Button'
import {InputDate} from '../../../../../components/UI/Input'
import {Select} from '../../../../../components/UI/Select'
import {useKhipu} from '../../../../../hooks/useKhipu'
import {SelectOption} from '../../../../../models/utility.model'
import {ratioRoomingListSchema} from '../../../../../util/validationHoteleria'
import {useCentralServices} from '../../../hooks/useCentralServices'
import {useModules} from '../../../hooks/useModules'
import {
  RatioRoomimngListDto,
  RatioRoomingListBed,
  RatioRoomingListData,
  RatioRoomingListGuest,
} from '../../../models/reports.model'
import {getRatioRoomingListService} from '../../../services/ratio.service'
import {TableReportRatioRoomingListWrapper} from './Tables/TableReportRatioRoomingList'
import {TableReportRatioRoomingListBedGuest} from './Tables/TableReportRatioRoomingListBedGuest'
import {
  TableReportLiberacionGeneracionWrapper,
  type TableLiberacionGeneracionRef,
} from './Tables/TableReportLiberacionGeneracion'

const RatiosRoomingList: FC = () => {
  const methods = useForm<RatioRoomimngListDto>({
    resolver: yupResolver(ratioRoomingListSchema),
    defaultValues: {
      Fecha: moment().format('YYYY-MM-DD'),
      CompaniaId: '',
      ClienteId: '',
      SiteId: '',
      CampamentoId: '',
      ModuloId: '',
    },
  })
  const {
    control,
    formState: {errors},
    register,
    setValue,
    handleSubmit,
    setError,
    watch,
    reset,
  } = methods
  const [compani, setCompany] = useState<SelectOption[]>([{value: '', label: 'TODOS'}])
  const [client, setClient] = useState<SelectOption[]>([{value: '', label: 'TODOS'}])
  const [site, setSite] = useState<SelectOption[]>([{value: '', label: 'TODOS'}])
  const [camp, setCamp] = useState<SelectOption[]>([{value: '', label: 'TODOS'}])
  const [modules, setModules] = useState<SelectOption[]>([{value: '', label: 'TODOS'}])
  const [loading, setLoading] = useState<boolean>(false)
  const [dataRoomingListTable, setDataRoomingListTable] = useState<RatioRoomingListData[]>([])
  const [bedRoominglist, setBedRoomingList] = useState<RatioRoomingListBed[]>([])
  const [guestRoominglist, setGuestRoomingList] = useState<RatioRoomingListGuest[]>([])
  const [siteSelected, setSiteSelected] = useState<string | null>(null)
  const [dtoToSend, setDtoToSend] = useState<any>()
  const [total, setTotal] = useState<number>(0)
  const [selectedTabIndex, setSelectedTabIndex] = useState<number>(0)
  const liberacionRef = useRef<TableLiberacionGeneracionRef | null>(null)
  const [libButtonsState, setLibButtonsState] = useState({
    canLiberate: false,
    canGenerate: false,
    loading: false,
  })
  const libBtnsAnchorRef = useRef<HTMLDivElement | null>(null)

  const {searchValues} = useKhipu()

  const {getModules} = useModules()
  const {getCompanies, getClients, getSites, getCamps} = useCentralServices()
  ///
  ///

  const getCompaniesFn = async () => {
    const data = await getCompanies({isCombo: true}, 1)
    if (data.length === 1) {
      setValue('CompaniaId', data[0].value as string)
      setError('CompaniaId', {})
      await getClientsFn(data[0].value as string)
    }
    const allData = [{value: '', label: 'TODOS'}, ...data]
    setCompany(allData)
  }

  const getClientsFn = async (companyId: string) => {
    const data = await getClients({isCombo: true, companiaId: companyId}, 1)
    if (data.length === 1) {
      setValue('ClienteId', data[0].value as string)
      setError('ClienteId', {})
      await getSitesFn(data[0].value as string)
    }
    const allData = [{value: '', label: 'TODOS'}, ...data]
    setClient(allData)
  }

  const getSitesFn = async (clientId: string) => {
    const data = await getSites(
      {isCombo: true, clienteId: clientId, companiaId: watch('CompaniaId')},
      1,
    )
    if (data.length === 1) {
      setValue('SiteId', data[0].value as string)
      setError('SiteId', {})
      setSiteSelected(data[0].value as string)
      await getCampsFn(data[0].value as string)
    }
    const allData = [{value: '', label: 'TODOS'}, ...data]
    setSite(allData)
  }

  const getCampsFn = async (siteId: string) => {
    const data = await getCamps(
      {
        isCombo: true,
        siteId: siteId,
        companiaId: watch('CompaniaId'),
        clienteId: watch('ClienteId'),
      },
      1,
    )
    if (data.length === 1) {
      setValue('CampamentoId', data[0].value as string)
      setError('CampamentoId', {})
      await getModulesFn(data[0].value as string)
    }
    const allData = [{value: '', label: 'TODOS'}, ...data]
    setCamp(allData)
  }

  const getModulesFn = async (campId: string) => {
    const data = await getModules({
      CampamentoId: campId,
      CompaniaId: watch('CompaniaId'),
      ClienteId: watch('ClienteId'),
      SiteId: watch('SiteId'),
    })
    const allData = [{value: '', label: 'TODOS'}, ...data]
    setModules(allData)
  }

  useEffect(() => {
    getCompaniesFn()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getRatios = async (datafilter: any = null) => {
    try {
      setLoading(true)
      const obj = {...(watch() as any)}
      for (var clave in obj) {
        if (obj.hasOwnProperty(clave)) {
          if (obj[clave] === '') {
            obj[clave] = null
          }
        }
      }
      const formValue = {
        pageNumber: 1,
        size: 10,
        ...obj,
        ...searchValues,
        ...datafilter,
        ...(searchValues.CamaCaliente === 'SI'
          ? {CamaCaliente: true}
          : searchValues.CamaCaliente === 'NO'
          ? {CamaCaliente: false}
          : {CamaCaliente: null}),
      }
      setDtoToSend(formValue)
      const {data: response} = await getRatioRoomingListService(formValue)
      if (!response.error) {
        setTotal(response.total)
        let arrBeds: RatioRoomingListBed[] = [
          {
            Resumen: 'Total Camas (C.I + C.C)',
            Cantidad: response.TotalCamas,
            Porcentaje: response.TotalCamasPorc,
          },
          {
            Resumen: 'Total Ocupadas (C.I + C.C)',
            Cantidad: response.TotalCamasOcupadas,
            Porcentaje: response.TotalCamasOcupadasPorc,
          },
          {
            Resumen: 'Total Disponibles',
            Cantidad: response.TotalCamasDisponibles,
            Porcentaje: response.TotalCamasDisponiblesPorc,
          },
          {
            Resumen: 'Total Salidas Programadas',
            Cantidad: response.TotalSalidasProgramadas,
            Porcentaje: '',
          },
          {
            Resumen: 'Total Continuan Programadas',
            Cantidad: response.TotalContinuanProgramadas,
            Porcentaje: '',
          },
          {
            Resumen: 'Total Sucias',
            Cantidad: response.TotalCamasSucias,
            Porcentaje: response.TotalCamasSuciasPorc,
          },
          {
            Resumen: 'Total Bloqueadas',
            Cantidad: response.TotalCamasBloqueadas,
            Porcentaje: response.TotalCamasBloqueadasPorc,
          },
          {
            Resumen: 'Total Reservadas',
            Cantidad: response.TotalCamasReservadas,
            Porcentaje: response.TotalCamasReservadasPorc,
          },
        ]
        setBedRoomingList(arrBeds)
        let arrGuest: RatioRoomingListGuest[] = [
          {
            Resumen: 'Nro. de Huespedes',
            Cantidad: response.CantHuesped,
          },
          {
            Resumen: 'Huespedes Salientes con salida programada',
            Cantidad: response.CantHuespedSalientes,
          },
          {
            Resumen: 'Huespedes que permanecen en el campamento',
            Cantidad: response.CantHuespedContinuan,
          },
        ]
        setGuestRoomingList(arrGuest)
        setDataRoomingListTable(response.data)
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  const onSubmit = (dataForm: any) => {
    // Preparar los valores del formulario (igual que en getRatios)
    const obj = {...(watch() as any)}
    for (var clave in obj) {
      if (obj.hasOwnProperty(clave)) {
        if (obj[clave] === '') {
          obj[clave] = null
        }
      }
    }
    const formValueToSend = {pageNumber: 1, size: 10, ...obj, ...searchValues}
    setDtoToSend(formValueToSend)

    // Si estamos en el tab de liberación (índice 2), usar su búsqueda
    if (selectedTabIndex === 2) {
      if (liberacionRef.current) {
        console.log('Calling handleSearch from liberacion tab with formValue:', formValueToSend)
        liberacionRef.current.handleSearch()
      } else {
        console.warn('liberacionRef.current is null')
      }
    } else {
      // Para los otros tabs, usar la búsqueda normal
      getRatios()
    }
  }

  const handleChangeDate = (val: any) => {
    let value = val ? val.target.value : ''
    setValue('Fecha', value)
    setError('Fecha', {})
  }

  const handleFilterClient = (e: any) => {
    let value = e.value
    setValue('ClienteId', '')
    setValue('SiteId', '')
    setValue('CampamentoId', '')
    setValue('ModuloId', '')
    getClientsFn(value)
    setValue('CompaniaId', value)
    setError('CompaniaId', {})
    setClient([])
    setSite([])
    setCamp([])
    setModules([])
  }

  const handleFilterSite = (e: any) => {
    let value = e.value
    setValue('SiteId', '')
    setValue('CampamentoId', '')
    setValue('ModuloId', '')
    getSitesFn(value)
    setValue('ClienteId', value)
    setError('ClienteId', {})
    setSite([])
    setCamp([])
    setModules([])
  }

  const handleFilterCamp = (e: any) => {
    let value = e.value
    setValue('CampamentoId', '')
    setValue('ModuloId', '')
    getCampsFn(value)
    setValue('SiteId', value)
    setError('SiteId', {})
    setSiteSelected(value)
    setCamp([])
    setModules([])
  }

  const handleFilterModule = (e: any) => {
    let value = e.value
    setValue('ModuloId', '')
    getModulesFn(value)
    setValue('CampamentoId', value)
    setError('CampamentoId', {})
    setModules([])
  }

  const handleClear = () => {
    reset({
      Fecha: moment().format('YYYY-MM-DD'),
      CompaniaId: '',
      ClienteId: '',
      SiteId: '',
      CampamentoId: '',
      ModuloId: '',
    })
    setClient([{value: '', label: 'TODOS'}])
    setSite([{value: '', label: 'TODOS'}])
    setCamp([{value: '', label: 'TODOS'}])
    setModules([{value: '', label: 'TODOS'}])
    setDataRoomingListTable([])
    setSiteSelected(null)
    setDtoToSend(null)
  }

  return (
    <>
      <KTCard shadow className='m-5'>
        <div className='pt-6 px-6'>
          <FormProvider {...methods}>
            <form>
              <div className='row'>
                <div className='col-sm-12 col-lg-3'>
                  <label className='required'>Compañía:</label>
                  <Select
                    control={control}
                    name='CompaniaId'
                    data={compani}
                    errors={errors}
                    onChangeValue={handleFilterClient}
                  />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <label className='required'>Cliente:</label>
                  <Select
                    control={control}
                    name='ClienteId'
                    data={client}
                    errors={errors}
                    onChangeValue={handleFilterSite}
                  />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <label className='required'>Site:</label>
                  <Select
                    control={control}
                    name='SiteId'
                    data={site}
                    errors={errors}
                    onChangeValue={handleFilterCamp}
                  />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <label className='required'>Campamento:</label>
                  <Select
                    control={control}
                    name='CampamentoId'
                    data={camp}
                    errors={errors}
                    onChangeValue={handleFilterModule}
                  />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <label className='required'>Módulo:</label>
                  <Select control={control} name='ModuloId' data={modules} errors={errors} />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <label className='required'>Fecha :</label>
                  <InputDate
                    name='Fecha'
                    register={register}
                    errors={errors}
                    onChange={handleChangeDate}
                    maxValue={moment().format('YYYY-MM-DD')}
                  />
                </div>
                <div className='col-sm-12 col-lg-6 d-flex align-items-center justify-content-between'>
                  <ButtonWrapper className={'sdx-white-bg'}>
                    <Button label='Buscar' onClick={handleSubmit(onSubmit)} />
                    <Button label='Limpiar' onClick={handleClear} />
                    {selectedTabIndex === 2 && (
                      <Button
                        label='Exportar'
                        onClick={() => liberacionRef.current?.handleExportExcel()}
                      />
                    )}
                    {/* Versión móvil de los botones (se ocultan en escritorio) */}
                    {selectedTabIndex === 2 && (
                      <>
                        <div className='d-lg-none'>
                          <Button
                            label='Liberación'
                            classNameProp='btn btn-warning'
                            onClick={() => liberacionRef.current?.handleLiberacion()}
                            disabled={!libButtonsState.canLiberate || libButtonsState.loading}
                          />
                          <Button
                            label='Generación'
                            onClick={() => liberacionRef.current?.handleGeneracion()}
                            disabled={!libButtonsState.canGenerate || libButtonsState.loading}
                          />
                        </div>
                      </>
                    )}
                  </ButtonWrapper>
                </div>
              </div>
              {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
            </form>
          </FormProvider>
        </div>
        <div className='sdx_content_tab_panel'>
          <Tabs
            className={'sdx_sub_react_tab_panel '}
            onSelect={(index) => setSelectedTabIndex(index)}
            selectedIndex={selectedTabIndex}
          >
            <TabList className={'sdx_sub_tab_panel p-0'}>
              <Tab className={'sdx_sub_tab_panel_option'}>Rooming List</Tab>
              <Tab className={'sdx_sub_tab_panel_option'}>Resumen de Camas y Huéspedes</Tab>
              <Tab className={'sdx_sub_tab_panel_option'}>Liberación y Generación</Tab>
            </TabList>
            <TabPanel>
              <TableReportRatioRoomingListWrapper
                datos={dataRoomingListTable}
                loading={loading}
                total={total}
                siteSelected={siteSelected}
                formValue={dtoToSend}
                getRatios={getRatios}
              />
            </TabPanel>
            <TabPanel>
              <TableReportRatioRoomingListBedGuest
                // dataBed={bedRoominglist}
                // dataGuest={guestRoominglist}
                // loading={loading}
                formValue={dtoToSend}
              />
            </TabPanel>
            <TabPanel>
              <TableReportLiberacionGeneracionWrapper
                formValue={dtoToSend}
                ref={liberacionRef}
                onStatusChange={(s) => setLibButtonsState(s)}
                paginationLeftActions={
                  <div
                    ref={libBtnsAnchorRef}
                    className='d-none d-lg-flex align-items-center'
                    style={{gap: '8px'}}
                  >
                    <Button
                      label='Liberación'
                      classNameProp='btn btn-warning'
                      onClick={() => liberacionRef.current?.handleLiberacion()}
                      disabled={!libButtonsState.canLiberate || libButtonsState.loading}
                    />
                    <Button
                      label='Generación'
                      onClick={() => liberacionRef.current?.handleGeneracion()}
                      disabled={!libButtonsState.canGenerate || libButtonsState.loading}
                    />
                  </div>
                }
              />
            </TabPanel>
          </Tabs>
        </div>
      </KTCard>
    </>
  )
}

export {RatiosRoomingList}
